import reembolso from 'assets/images/reembolso.png';
import horario from 'assets/images/horario.png';
import policlinicos from 'assets/images/policlinicos.png';
import citas from 'assets/images/citas.png';
import afiliacion from 'assets/images/afiliacion.png';
import medicamentos from 'assets/images/medicamentos.png';
import tramites from 'assets/images/tramites.png';
import tramitesEspeciales from 'assets/images/tramites-especiales.png';
import datos from 'assets/images/datos.png';
import homologar from 'assets/images/homologar.png';
import ingreso from 'assets/images/ingreso.png';
import category from 'assets/images/category.png';

export const categoriesMock = [
	{
		rutaIcono: 'reembolso',
		descripcion: 'Reembolso',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'horario',
		descripcion: 'Horario de atención',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'policlinicos',
		descripcion: 'Ubicación policlínicos y consultorios',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'citas',
		descripcion: 'Calendarización de citas',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'afiliacion',
		descripcion: 'Afiliación',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'medicamentos',
		descripcion: 'Existencia de medicamentos',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'tramites',
		descripcion: 'Trámites para medicamentos',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'tramitesEspeciales',
		descripcion: 'Trámites para medicamentos especiales',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'datos',
		descripcion: 'Estado de afiliación',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'homologar',
		descripcion: 'Homologación de incapacidades',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
	{
		rutaIcono: 'ingreso',
		descripcion: 'Ingreso a centro recreativo magisterial',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
  {
		rutaIcono: 'no-existe',
		descripcion: 'Categoría comodín',
		faqPreguntas: [
			{
				pregunta: 'Pregunta 1',
				respuesta: 'Contenido Pregunta 1',
			},
			{
				pregunta: 'Pregunta 2',
				respuesta: 'Contenido Pregunta 2',
			},
		],
	},
];

const images = {
  reembolso,
  horario,
  policlinicos,
  citas,
  afiliacion,
  medicamentos,
  tramites,
  tramitesEspeciales,
  datos,
  homologar,
  ingreso,
};

export const getImage = (path: keyof typeof images) => {
  if ((path in images)) {
    return images[path];
  }
  return category;
};
